import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Container, Form, Row, Table } from 'react-bootstrap';
import Breadcrumb from '../../../Common/BreadCrumb';
import { Link, useParams, useLocation } from 'react-router-dom';
import Flatpickr from "react-flatpickr";
import Dropzone from "react-dropzone";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import StepOneProduct from './StepOneProduct';
import StepTwoProduct from './StepTwoProduct';
import { useDispatch, useSelector } from 'react-redux';
import { getProductInfos, getProductStep, setCleanProductinfo, setProductInfo, useProductListMutation, useProductShowMutation, useProductShowQuery } from '../../../Redux/ProductSlice';
import StepThreeProduct from './StepThreeProduct';
import StepFourProduct from './StepFourProduct';
import { setSelectedCategory } from '../../../Redux/CategorySlice';
import StepSpecification from './StepSpecification';
import StepProductColorVarient from './StepProductColorVarient';


const CreateProduct = () => {

    document.title = "Create Product | Toner eCommerce + Admin React Template";
    const location = useLocation()


    const getProducInfo = useSelector(getProductInfos);
    const productStep = useSelector(getProductStep);

    const { productId } = useParams()

    const dispatch = useDispatch();

    const { data, error: createErr, isLoading: showLoading } = useProductShowQuery(productId, { skip: !productId });
    console.log(data, "datadatadata");
    useEffect(() => {
        if (data?.response?.id) {
            const pdId = getProducInfo?.id || getProducInfo?.productId;

            const stepTwoRes = data?.response;

            const productSizeColourCombinationsData = stepTwoRes?.ProductSizeColourCombinations?.map(it => ({ id: it?.id, MRP: it?.MRP, quantity: it?.quantity, maxOrderQuantity: it?.maxOrderQuantity, sellingPrice: it?.sellingPrice, skuId: it?.skuId, productColourId: { value: it?.ProductColour?.id, label: it?.ProductColour?.name }, sizeId: { value: it?.Size?.id, label: it?.Size?.name } }));
            const productSizeImgColourData = stepTwoRes?.ProductImageColourCombinations?.map(it => ({ ...it, productColourId: { value: it?.productColourId, label: it?.ProductColour?.name } }));


            dispatch(setProductInfo({
                ...data?.response,
                "productId": pdId
                ,
                "sizes": stepTwoRes?.ProductSizeCombinations?.map(it => ({
                    value: it?.sizeId, label: it?.Size?.name
                })),
                "colours": stepTwoRes?.ProductColourCombinations?.map(it => ({
                    value: it?.productColourId, label: it?.ProductColour?.name
                })),
                "productImageColourData": productSizeImgColourData,
                "productSizeColourData": productSizeColourCombinationsData,
                'sizesShowData': stepTwoRes?.ProductSizeCombinations?.map(it => ({
                    value: it?.sizeId, label: it?.Size?.name
                })),
                "colorsShowData": stepTwoRes?.ProductColourCombinations?.map(it => ({
                    value: it?.productColourId, label: it?.ProductColour?.name
                })),
                // }

            }))
            dispatch(setSelectedCategory(data?.response?.ProductCategoryCombinations?.map(it => it?.categoryId)))
        }
    }, [data]);

    useEffect(() => {
        if (location.pathname === "/product-create") {
            dispatch(setCleanProductinfo())
        }
    }, [location])



    const [categoryId, setCategoryId] = useState('');


    const [productListFn, { data: productList, isSuccess, error, isLoading }] = useProductListMutation();

    useEffect(() => {
        if (productStep === 'STEP1' || productStep === 'STEP4') {


            productListFn(`categoryId:${JSON.stringify(categoryId)}`)

        }
    }, [productStep, categoryId])




    return (
        <>
            <div className="page-content">

                {
                    showLoading ? <div className="spinner-border " role="status">

                    </div> :

                        <Container fluid={true}>
                            <Breadcrumb title={location.pathname.includes('/product-edit') ? "Update Product" : "Create Product"} pageTitle="Products" />

                            {/* Basic Information form Step-1 */}


                            {
                                productStep === 'STEP1' && <StepOneProduct key={"StepOneProduct"} />
                            }
                            {
                                productStep === 'STEP2' && <StepSpecification key={"StepSpecification"} />
                            }
                            {
                                productStep === 'STEP3' && <StepTwoProduct key={"StepTwoProduct"} />
                            }


                            {/* {
                                productStep === 'STEP4' && <StepProductColorVarient productList={productList} categoryId={categoryId} setCategoryId={setCategoryId} />
                            } */}

                            {
                                productStep === 'STEP4' && <StepThreeProduct productList={productList} />
                            }
                            {/* {
                                productStep === 'STEP5' && <StepFourProduct productList={productList} />
                            } */}




                            {/* product variant form Step-2 */}

                        </Container>
                }
            </div>


        </ >
    );
}

export default CreateProduct;